import { render, staticRenderFns } from "./SmallCategoryCreateOrEdit.vue?vue&type=template&id=753cb8e3&"
import script from "./SmallCategoryCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./SmallCategoryCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports